import {
    OrderEntry,
    EntryType,
    OrderEntryType,
    OrderSheetPageSetType,
    OrderSheetPageSet,
    PointPromotionApiResultValues,
    PromotionStatusType,
    PointPromotionApiResult,
    PromotionStatus,
} from '@web/core/constants'
import {
    RoutersCheckoutPathGroup,
    ROUTER_ORDER_CHECK_OUT,
    ROUTER_ORDER_RESULT,
    ROUTER_ORDER_SHEET,
} from '@web/core/routes'

/** 주문완료시 이동하는 경로 */
export const getOrderResultUrl = (entry: Maybe<EntryType>, orderNo: string | number) => {
    const resultUrl = (function () {
        switch (entry) {
            case OrderEntry.CHECKOUT:
                return ROUTER_ORDER_RESULT.MALL
            case OrderEntry.NAVER_BLOG:
                return ROUTER_ORDER_RESULT.BLOG
            case OrderEntry.EASY_BOOKING:
                return ROUTER_ORDER_RESULT.EASY_BOOKING
            case OrderEntry.LOCAL_PAY:
                // v2 : tableOrder 포함
                return ROUTER_ORDER_RESULT.LOCAL_PAY
            default:
                return ROUTER_ORDER_RESULT.MALL
        }
    })()
    return `${resultUrl}/${orderNo}`
}

export const getChannelUrlMap = (serviceChannel: string) => {
    const UrlMap: Record<string, RoutersCheckoutPathGroup> = {
        [OrderEntry.CHECKOUT]: ROUTER_ORDER_SHEET.MALL,
        [OrderEntry.EASY_BOOKING]: ROUTER_ORDER_SHEET.EASY_BOOKING,
        [OrderEntry.LOCAL_PAY]: ROUTER_ORDER_SHEET.LOCAL_PAY,
        [OrderEntry.NAVER_BLOG]: ROUTER_ORDER_SHEET.BLOG,
    }
    return serviceChannel ? (UrlMap[serviceChannel] ?? ROUTER_ORDER_SHEET.MALL) : ROUTER_ORDER_SHEET.MALL
}

/** 주문서 경로 OR Route entry 정보를 entry 으로 변환합니다. */
export const getOrderRouteChannel = (orderEntry: string, routeEntry: EntryType = OrderEntry.CHECKOUT) => {
    const channelMap: Record<string, OrderEntryType> = {
        mall: OrderEntry.CHECKOUT,
        blog: OrderEntry.NAVER_BLOG,
        easybooking: OrderEntry.EASY_BOOKING,
        localpay: OrderEntry.LOCAL_PAY,
    }
    if (!orderEntry) {
        return routeEntry
    }
    return channelMap[orderEntry] ?? OrderEntry.CHECKOUT
}

const PageSetlMap: Record<string, OrderSheetPageSetType> = {
    mall: OrderSheetPageSet.MALL,
    blog: OrderSheetPageSet.EASYBOOKING,
    easybooking: OrderSheetPageSet.EASYBOOKING,
    localpay: OrderSheetPageSet.EASYBOOKING,
}

const RoutePageSetlMap: Record<string, OrderSheetPageSetType> = {
    [OrderEntry.CHECKOUT]: OrderSheetPageSet.MALL,
    [OrderEntry.NAVER_BLOG]: OrderSheetPageSet.EASYBOOKING,
    [OrderEntry.EASY_BOOKING]: OrderSheetPageSet.EASYBOOKING,
    [OrderEntry.LOCAL_PAY]: OrderSheetPageSet.EASYBOOKING,
}

/** 주문서 경로 OR Route entry 정보를 PageSet 으로 변환합니다. */
export const getOrderRouteChannelGroup = (orderChannel: string, routeChannel: EntryType = OrderEntry.CHECKOUT) => {
    if (!orderChannel) {
        return RoutePageSetlMap[routeChannel] ?? OrderSheetPageSet.MALL
    }
    return PageSetlMap[orderChannel] ?? OrderSheetPageSet.MALL
}

const CheckOutUrlMap: Record<string, string> = {
    easybooking: ROUTER_ORDER_CHECK_OUT.EASY_BOOKING,
    localpay: ROUTER_ORDER_CHECK_OUT.LOCAL_PAY,
    blog: ROUTER_ORDER_CHECK_OUT.BLOG,
    mall: ROUTER_ORDER_CHECK_OUT.MALL,
}

const CheckOutRouteUrlMap: Record<string, string> = {
    [OrderEntry.CHECKOUT]: ROUTER_ORDER_CHECK_OUT.MALL,
    [OrderEntry.EASY_BOOKING]: ROUTER_ORDER_CHECK_OUT.EASY_BOOKING,
    [OrderEntry.LOCAL_PAY]: ROUTER_ORDER_CHECK_OUT.LOCAL_PAY,
    [OrderEntry.NAVER_BLOG]: ROUTER_ORDER_CHECK_OUT.BLOG,
}

/** 주문서 경로 OR Route entry 정보를 url 으로 변환합니다. */
export const getOrderCheckoutRouteUrl = (orderEntry: string, routeEntry: EntryType = OrderEntry.CHECKOUT) => {
    if (!orderEntry) {
        return CheckOutRouteUrlMap[routeEntry] ?? ROUTER_ORDER_CHECK_OUT.MALL
    }
    return `${window.location.origin}${CheckOutUrlMap[orderEntry] ?? ROUTER_ORDER_CHECK_OUT.MALL}`
}

export const getPointPromotionStatusByApiResult = (
    apiResult: PointPromotionApiResultValues | undefined,
): PromotionStatusType => {
    switch (apiResult) {
        case PointPromotionApiResult.SUCCESS:
            return PromotionStatus.AVAILABLE
        case PointPromotionApiResult.FAILED:
            return PromotionStatus.UNAVAILABLE
        case PointPromotionApiResult.NO_APPLICABLE_PROMOTION:
            return PromotionStatus.NO_AVAILABLE_PROMOTION
        case PointPromotionApiResult.NO_PROMOTION_TARGET:
        default:
            return PromotionStatus.NO_PROMOTION
    }
}
